import React, { useContext } from "react";
import Filter from "../../filters/filter";
import "./overview.css";
import {
  overviewFilterSchema,
  overviewFilterSchemaForFailureReason,
} from "../schema/overviewSchema/overviewFilterSchema";
import AnalyticsContext from "../analyticsContext";
import OverviewVolCountGraph from "./overviewVolCountGraph";
import AnalyticsKPI from "../AnalyticsKPI";
import { OverviewAnalyticsStates } from "./OverviewContext";
import ContainerWithTab from "../../../reusableComponents/conatinerWithTabs/ContainerWithTab";
import {
  failureTableSchema,
  paymentByProcessorSchema,
} from "./overViewTableSchemas";
import AnalyticsTable from "../analyticsTable";
import PieChartComponent from "../checkout/subheaders/paymentMethodSplit/PieChartComponent";

export default function Overview() {
  const {
    averageTicketSize,
    successRate,
    totalAmount,
    totalPayment,
    locale,
    logo,
    paymentData,
    gmvPspData,
    setWithSearchbarModalDataForGraph,
    chartTransactionOverAll,
    volumeTransactionOverAll,
    failureReasonTableData,
    failureReasonChartData,
    setWithSearchbarModalDataForFailureReason,
    singleStartDate,
    startDate,
    endDate,
  } = OverviewAnalyticsStates();

  const selectedDropdownValue = useContext(AnalyticsContext);

  const showExternalStyling = true;
  const showPercentageKpi = true;

  const handleSearchbarModalDataForGraph = (data) => {
    setWithSearchbarModalDataForGraph(data);
  };

  const handleSearchbarModalDataForFailureReason = (data) => {
    setWithSearchbarModalDataForFailureReason(data);
  };

  return (
    <>
      <div className="overview-analytics-root">
        <div className="kpi-conatiner">
          {[...Array(4)].map((e, i) => (
            <AnalyticsKPI
              key={i}
              data={
                i === 0
                  ? totalPayment
                  : i === 1
                    ? totalAmount
                    : i === 2
                      ? averageTicketSize
                      : successRate
              }
              showPercentageKpi={showPercentageKpi}
              showStyling={showExternalStyling}
              selectedDropdownValue={selectedDropdownValue}
              isTransactionVolumeFromAnalytics={true}
              kpiPage={"payment_link_analytics"}
              singleStartDate={singleStartDate}
            />
          ))}
        </div>
        <div className="overview-analytics-contnet">
          <ContainerWithTab
            contentStyle={{ height: "400px" }}
            filters={
              <Filter
                filteredSchema={overviewFilterSchema}
                handleSearchbarModalData={handleSearchbarModalDataForGraph}
                useTabStyling={true}
              />
            }
            tabs={[
              {
                header: "Sales",
                tabTitle: "Chart",
                content: locale !== "" && (
                  <OverviewVolCountGraph
                    selectedDropdownValue={selectedDropdownValue}
                    chartTransactionOverAll={chartTransactionOverAll}
                    volumeTransactionOverAll={volumeTransactionOverAll}
                    locale={locale}
                    singleStartDate={singleStartDate}
                    startDate={startDate}
                    endDate={endDate}
                  />
                ),
              },
            ]}
          />
          <ContainerWithTab
            filters={
              <Filter
                filteredSchema={overviewFilterSchemaForFailureReason}
                handleSearchbarModalData={
                  handleSearchbarModalDataForFailureReason
                }
                useTabStyling={true}
              />
            }
            tabs={[
              {
                header: "Failed Transactions",
                subHeader: "By Transaction Count",
                tabTitle: "Pie Chart",
                content: (
                  <PieChartComponent
                    data={failureReasonChartData?.chartDataPoints}
                    chartOptions={failureReasonChartData?.chartOptions}
                    pieChartData={failureReasonChartData?.chartData}
                  />
                ),
              },
              {
                header: "Failed Transactions",
                subHeader: "By Transaction Count",
                tabTitle: "Table",
                content: (
                  <AnalyticsTable
                    schema={failureTableSchema}
                    data={failureReasonTableData?.tableData}
                    default_orderBy={"value"}
                  />
                ),
              },
            ]}
          />
          <ContainerWithTab
            tabs={[
              {
                header: "Transactions by Processors",
                subHeader: "By Value",
                tabTitle: "Table",
                content: (
                  <AnalyticsTable
                    schema={paymentByProcessorSchema}
                    logoDict={logo}
                    tableTitle="Payment Link Status Analysis"
                    data={gmvPspData}
                    default_orderBy={"gmvLocale"}
                    showLogo={true}
                  />
                ),
              },
            ]}
          />
        </div>
      </div>
    </>
  );
}
